module.exports = __webpack_public_path__ + "img/leftcalf-mesomorph-male.dc797c7d.svg";